import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./styles/globals.css";
import { installDebugCapture } from "./lib/debugLog";

// Install fetch / console capture before anything else mounts, so the
// debug panel has the full request + error history from page load.
installDebugCapture();

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);

// Register the service worker for the app-shell cache + install prompt.
// Only in browsers that support it, and only when not on localhost dev so
// the live-reload page stays predictable. The SW is otherwise idempotent.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    if (location.hostname === "localhost" || location.hostname === "127.0.0.1") return;
    navigator.serviceWorker.register("/service-worker.js").catch((err) => {
      // Non-fatal — log so the dev sees it, don't crash the app.
      // eslint-disable-next-line no-console
      console.warn("[dreambook] SW register failed:", err);
    });
  });
}
